import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { formatPersonaDateTime } from "../../utils";

const MAX_COMMENT_LENGTH = 200;

const textValue = (value) =>
  typeof value === "string" && value.trim().length > 0 ? value.trim() : "";

export const getLastCommentText = (comment) => {
  if (!comment) {
    return "";
  }
  if (typeof comment === "string") {
    return textValue(comment);
  }
  return textValue(comment.comment || comment.message || comment.text);
};

const getAuthorName = (comment) => {
  if (!comment || typeof comment === "string") {
    return "";
  }

  return (
    comment.sender?.full_name ||
    comment.author?.full_name ||
    comment.user?.full_name ||
    comment.created_by?.full_name ||
    comment.sender_name ||
    comment.author_name ||
    ""
  );
};

const getCommentDate = (comment) => {
  if (!comment || typeof comment === "string") {
    return "";
  }

  return (
    comment.created_at ||
    comment.updated_at ||
    comment.date ||
    comment.last_date_update ||
    ""
  );
};

const LastCommentNote = ({ comment }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const text = getLastCommentText(comment);

  if (!text) {
    return <span className="text-muted">-</span>;
  }

  const author = getAuthorName(comment);
  const date = getCommentDate(comment);
  const formattedDate = date ? formatPersonaDateTime(date) : "";
  const isLongComment = text.length > MAX_COMMENT_LENGTH;
  const visibleText = isLongComment
    ? `${text.slice(0, MAX_COMMENT_LENGTH).trim()}...`
    : text;

  return (
    <>
      <figure
        className="mb-0"
        style={{
          minWidth: "230px",
          maxWidth: "380px",
          borderLeft: "3px solid var(--bs-blue)",
          background: "#f4f9ff",
          borderRadius: "4px",
          padding: "8px 10px",
        }}
      >
        <blockquote
          className="mb-1"
          style={{
            color: "#2f3a45",
            fontSize: "0.72rem",
            lineHeight: 1.35,
            margin: 0,
            textAlign: "justify",
            whiteSpace: "pre-line",
            wordBreak: "break-word",
          }}
        >
          {visibleText}
          {isLongComment ? (
            <button
              type="button"
              className="btn btn-primary btn-sm ms-1 py-0 px-2"
              style={{ fontSize: "0.65rem", lineHeight: 1.25 }}
              onClick={() => setIsModalOpen(true)}
            >
              Ver mas
            </button>
          ) : null}
        </blockquote>
        {author || formattedDate ? (
          <figcaption
            className="mt-2"
            style={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <div
              className="badge text-blue px-2 pt-5px pb-5px rounded fs-12px d-inline-flex flex-column"
              style={{
                maxWidth: "100%",
                textAlign: "left",
                whiteSpace: "normal",
              }}
            >
              <span style={{ fontSize: "0.68rem", lineHeight: 1.2 }}>
                <i className="fa fa-circle fs-9px fa-fw me-5px text-blue"></i>
                <span className="fw-bold text-blue">{author || "-"}</span>
                {formattedDate ? (
                  <span className="text-secondary ms-1">| {formattedDate}</span>
                ) : null}
              </span>
            </div>
          </figcaption>
        ) : null}
      </figure>
      <Modal isOpen={isModalOpen}>
        <ModalHeader
          close={
            <button
              className="btn-close"
              onClick={() => setIsModalOpen(false)}
            ></button>
          }
        >
          Comentario completo
        </ModalHeader>
        <ModalBody>
          <div
            style={{
              color: "#2f3a45",
              fontSize: "0.85rem",
              lineHeight: 1.5,
              textAlign: "justify",
              whiteSpace: "pre-line",
              wordBreak: "break-word",
            }}
          >
            {text}
          </div>
          {author || formattedDate ? (
            <div className="d-flex justify-content-end mt-3">
              <div
                className="badge text-blue px-2 pt-5px pb-5px rounded fs-12px d-inline-flex flex-column"
                style={{ textAlign: "left", whiteSpace: "normal" }}
              >
                <span style={{ fontSize: "0.72rem", lineHeight: 1.2 }}>
                  <i className="fa fa-circle fs-9px fa-fw me-5px text-blue"></i>
                  <span className="fw-bold text-blue">{author || "-"}</span>
                  {formattedDate ? (
                    <span className="text-secondary ms-1">
                      | {formattedDate}
                    </span>
                  ) : null}
                </span>
              </div>
            </div>
          ) : null}
        </ModalBody>
        <ModalFooter>
          <button
            className="btn btn-white"
            onClick={() => setIsModalOpen(false)}
          >
            Cerrar
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default LastCommentNote;
